// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0643a95b","455":"c53d0e70","977":"f8506a02"}[chunkId] + ".chunk.js";
};